import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    card: {
      display: 'flex',
      flexDirection: 'column',
      padding: spacing(5),
      paddingBottom: 19,
      backgroundColor: colors.grey.body,
      marginTop: 0,
      overflow: 'visible',
    },
    cardHeader: {
      marginBottom: spacing(4),
    },
    cardTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
    },
    radioRoot: {
      marginBottom: spacing(3),
    },
    radioWrapper: {
      marginRight: spacing(3),
    },
    labelRoot: {
      fontWeight: 400,
    },
    lookupSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
      marginTop: spacing(4),
    },
  });
